import { API_URL } from '../config';

export const URL_GENERATE_PDF = `${API_URL}/api/custom/public/shipping/tags/merge`;
